// removed by extract-text-webpack-plugin
module.exports = {"field":"_10JJvbrQocSR5omU5qbJay","error":"_1BPbC3XuAMXrgb0lsX-5ei","label":"N0jIrKk9gAceGB4bkSu0K","required":"Gqv6hcQJGH2ukv9Mtvb_r"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/ContactPersonField/ContactPersonField.scss
// module id = 1792
// module chunks = 0